import { Modal, Stack, TextInput, FileInput, Button, Group, rem } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { useState } from 'react';
import { PackageService } from '../../types';

interface Props {
    opened: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export function AddExpectedPackageModal({ opened, onClose, onSuccess }: Props) {
    const [note, setNote] = useState('');
    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!note || !file) return;

        setLoading(true);
        try {
            await PackageService.postPackageExpect({
                note,
                invoice_image: file ? URL.createObjectURL(file) : ''
            });
            onSuccess();
            onClose();
            setNote('');
            setFile(null);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Add Expected Package"
            centered
            size="md"
            padding="md"
        >
            <form onSubmit={handleSubmit}>
                <Stack gap="md">
                    <TextInput
                        label="Package Description"
                        placeholder="Enter package description"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        required
                    />

                    <FileInput
                        label="Invoice Image"
                        placeholder="Upload invoice image"
                        accept="image/*"
                        value={file}
                        onChange={setFile}
                        leftSection={<IconUpload size={rem(16)} />}
                        required
                    />

                    <Group justify="flex-end" gap="xs">
                        <Button variant="outline" onClick={onClose} size="sm">
                            Cancel
                        </Button>
                        <Button type="submit" loading={loading} size="sm">
                            Add Package
                        </Button>
                    </Group>
                </Stack>
            </form>
        </Modal>
    );
}
